import script from "./ESportsFixtureBook.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsFixtureBook.vue?vue&type=script&setup=true&lang=js"

import "./ESportsFixtureBook.vue?vue&type=style&index=0&id=29869f9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29869f9a"]])

export default __exports__